import { NOT_SET } from '@sunrise/tracking'

export default {
    mslayer_element_type_text: NOT_SET,
    mslayer_element_variant: NOT_SET,
    mslayer_element_count: NOT_SET,
    mslayer_element_body_type: 'text_body',
    mslayer_element_position: NOT_SET,
    mslayer_element_id: NOT_SET,
    mslayer_element_company_name: NOT_SET,
    mslayer_element_detail_start_date: NOT_SET,
}
